<template>
  <div>
    <!-- <div class="info-box">授权登录 享受更多精彩</div> -->
     <div class="info-box">
      <img src="@/static/img/logo.png"/>
     </div>
    <van-button type="info" round block class="authBtn" @click="authLogin"
      >授权登录</van-button
    >
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
export default {
  data() {
    return {};
  },
  mounted() {
    this.init();
  },

  computed: {
    ...mapState(["hasLogin", "userInfo", "openId", "config", "domain"]),
  },
  methods: {
    ...mapMutations([
      "login",
      "setOpenId",
      "setConfig",
      "setOrgInfo",
      "setdomain",
      "setFollow",
    ]),
    getOrgSetting() {
      this.$http.request(this.$http.pathMap.orgInfo).then((res) => {
        const config = res.data.template;
        this.setConfig(config);
        this.setOrgInfo(res.data);
        localStorage.setItem("name", res.data.name || "");
        localStorage.setItem("shareTitle", res.data.shareTitle || "");
        localStorage.setItem("desc", res.data.shareDescription || "");
        // #ifdef H5
        document.body.style.setProperty(
          "--theme-font-color",
          config.theme.fontColor
        );
        // #endif
      });
    },
    ...mapMutations(["login"]),
    init() {
      const href = window.location.href;
      let paramObj = {};
      if (href.indexOf("?") > -1) {
        const params = href.substr(href.indexOf("?") + 1, href.length);
        let paramArr = [];
        if (href.indexOf("&") > -1) {
          paramArr = params.split("&");
        }
        for (const param of paramArr) {
          const a = param.split("=");
          paramObj[a[0]] = a.length === 2 ? a[1] : "";
        }
      }
      // 判断是否有code
      if (paramObj.code) {
        this.requestOpenId(paramObj.code);
      }
    },
    authLogin() {
      let appId = localStorage.getItem("appId");
      let url = window.location.href;
      url = encodeURIComponent(url);
      const wxAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect`;
      window.location.href = wxAuthUrl;
    },
    requestOpenId(code) {
      let params = {
        code,
      };
      let recommender = this.getUrlParam("userId");
      if (recommender) {
        params.recommender = recommender;
      }
      const url = this.$http.pathMap.weChatLogin;
      this.$http.request(url, "get", params).then((res) => {
        if (res.data) {
          localStorage.setItem("token", res.data.token);
          this.getOrgSetting();
          localStorage.setItem('avatar',res.data.avatar)
          // this.getInfo(code);
          if (res.data.avatar) {
            let url = this.domain + "#" + this.$route.query.redirectUrl;
            window.location.href = url;
          }
        }
      });
    },
    getInfo(code) {
      let params = {
        code,
      };
      params.tenantId = localStorage.getItem("tenantId");
      const url = this.$http.pathMap.userInfo;
      this.$http.request(url, "get", params).then(async (res) => {
        await this.login(res.data);
        let follow = "";
        if (res.data.follow === null) {
          follow = "";
        }
        follow = res.data.follow;
        this.setFollow(follow);
        localStorage.setItem("userId", res.data.id);
        localStorage.setItem("tenantId", res.data.tenantId);
        localStorage.setItem("logo", res.data.logo || "");
        // this.$router.replace(this.$route.query.redirectUrl);
      });
    },
    getUrlParam(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = this.$route.query.redirectUrl.match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.authBtn {
  margin-top: 300px;
}
.info-box {
  width: 200px;
  height: 200px;
  margin: 100px auto 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
